function checkArray(array) {
  const r = ![null, undefined].includes(array) && Array.isArray(array) && !!Object.keys(array).length
  return r;
}

export const ArrayTools = {
  checkArray,
}

